/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {
    useCallback,
    useMemo,
    useContext,
    useState,
    useEffect
} from 'react';
import _ from 'lodash';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { MLProductCodeUtil, MLDisclosureUtil, MLEndorsementFlowUtil } from 'ml-portals-util-js';
import { MLPupLineValidatorUtil, MLNotificationBlockUtil, MLAvailableInsuredCandidatesUtil, MLDriverVehicleUtil } from 'ml-portals-util-react';
import { MLOutOfSequenceConflictComponent, MLPartialVehicleDetailsComponent } from 'ml-components-common-react';
import { VehiclesListPopupComponent } from 'ml-capability-quoteandbind-common-react'
import { useModal } from '@jutro/components';
import { FormModalPopover } from 'ml-components-platform-react';
import { MLTagManagerService } from 'ml-portals-services-react'
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { PolicyChange } from 'gw-capability-policychange-common-react';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { MLModalService } from 'ml-portals-services-react';
import { useMLLandingPageContext } from 'gw-capability-gateway-quoteandbind-common-react';
import { LocalDateUtil } from '@xengage/gw-portals-util-js';
import PolChangeTrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PolChangeTrackEvent.jsx';
import {
    MLNavigationStepsTrackingService,
    MLPolicyChangeDataHolderService,
    MLStateRolloutService
} from 'ml-services-common-react';
import { MLAddVehicleOperatorPopup, MLModalWithAlerts, MLVehicleOperatorListPopup, MLBusinessActivitiesListPopup, MLDriverChangeTablePopup, MLUnderlyingPoliciesListPopup, MLWatercraftListPopup, MLLocationListPopup, MLPUPVehicleListPopup, MLDriverDiscoveryReviewTablePopup, MLRentedTrailerCamperTablePopup } from 'ml-capability-policychange-common-react';
import Contact from '../../models/Contact';

import { Identify } from '../../../gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/TrackEvent';
import paWizardConfig from '../../../gw-capability-policychange-pa-react/config/pa-policychange-wizard-config.json5';
import hoWizardConfig from '../../../gw-capability-policychange-ho-react/config/ho-wizard-config.json5';
import pupWizardConfig from '../../../gw-capability-policychange-pup-react/config/pup-wizard-config.json5';
import ampPaWizardConfig from '../../../gw-capability-policychange-pa-react/config/pa-amp-wizard-config.json5';
import ampHoWizardConfig from '../../../gw-capability-policychange-ho-react/config/ho-amp-wizard-config.json5';
import ampPupWizardConfig from '../../../gw-capability-policychange-pup-react/config/pup-amp-wizard-config.json5';
import messages from './AdditionalChangesPage.messages';
import metadata from './AdditionalChangesPage.metadata.json5';

import newVehiclePopupMessages from '../../../../modules-react/ml-components-common-react/MLPartialVehicleDetailsComponent/MLPartialVehicleDetailsComponent.messages';

const endorsementQuoteDetails = 'endorsementQuoteDetails';

const alertNames = {
    removedBizActivityName: 'removedBizActivity',
    removedUnderlyingPolicyName: 'removedUnderlyingPolicy',
    addedUnderlyingPolicyName: 'addedUnderlyingPolicy',
    driverChangedToRatedPlsUpdateDriver: 'driverChangedToRatedPlsUpdateDriver',
    removedVehicleName: 'removedVehicle',
    addedVehicleName: 'addedVehicle',
    replacedVehicleName: 'replacedVehicle',
    removedLocationName: 'removedLocation',
    removedWatercraftName: 'removedWatercraft',
    removedWatercraftOperatorName: 'removedWatercraftOperator'
};
function AdditionalChangesPage(props) {
    const modalApi = useModal();
    const { authHeader } = useAuthentication();
    const translator = useTranslator();
    const viewModelService = useContext(ViewModelServiceContext);
    const {
        updateWizardData, changeNextSteps, currentStepIndex, wizardData, steps: currentSteps, currentStep, goNext
    } = props;
    const { submissionVM, alertMessages = [] } = wizardData;
    const { EndorsementService } = useDependencies('EndorsementService');
    const { additionalPolicyChangeProps } = useMLLandingPageContext();
    const [updatedSteps, setUpdatedSteps] = useState([]);

    const {
        addRemovedWatercraftOperatorToAvailableCandidates
    } = MLAvailableInsuredCandidatesUtil();

    const { showProgressDialog, hideProgressDialog } = MLModalService();
    const { endorsementValidateAllExposures } = MLPupLineValidatorUtil();
    const { addSuccessAlert, addWarningAlert, addErrorAlert, clearAlerts, getNumberOfAlerts, clearBlockAlerts, clearSuccessAlerts } = MLNotificationBlockUtil();

    const isOOSConflict = _.get(submissionVM, 'isOutOfSequenceConflict_ML.value');
    const isAgent = appConfig.portalCode === 'GPA';
    const isAmpMode = appConfig.portalCode === 'AMP';
    const isQnB = appConfig.portalCode === 'QB';

    const POLICYTYPE_TYPELIST = viewModelService.productMetadata.get('pc').types.getTypelist('PUPULPolicyType_PUE');
    const CARRIER_TYPELIST = viewModelService.productMetadata.get('pc').types.getTypelist('ULCarrier_PUE');
    const BODYTYPE_TYPELIST = viewModelService.productMetadata.get('pc').types.getTypelist('BodyType');

    const productCode = _.get(submissionVM, 'baseData.productCode.value', '');
    const isPersonalAuto = MLProductCodeUtil.isPersonalAuto(productCode);
    const isHomeowners = MLProductCodeUtil.isHomeOwners(productCode);
    const isPersonalUmbrella = MLProductCodeUtil.isPersonalUmbrella(productCode);
    const paModel = _.get(submissionVM, 'lobData.personalAuto');
    const pupModel = _.get(submissionVM, 'lobData.personalUmbrella');
    const vehiclesVM = _.get(submissionVM, 'lobData.personalAuto.coverables.vehicles');
    const paCoverableVal = _.get(submissionVM, 'lobData.personalAuto.coverables.value')
    const currentLob = paModel.value ? paModel : pupModel;
    const isModernProduct = _.get(submissionVM, 'isModernProduct_Ext.value', false);
    const isUMB_NP = isModernProduct && isPersonalUmbrella;

    const businessActivitiesVM = _.get(pupModel, 'coverables.businessActivities');
    const watercraftsVM = _.get(pupModel, 'coverables.watercrafts');
    const watercraftOperatorsVM = _.get(pupModel, 'coverables.watercraftOperators');
    const vehicleOperatorsVM = _.get(pupModel, 'coverables.vehicleOperators');
    const underlyingPoliciesVM = _.get(pupModel, 'underlyingPolicies');
    const locationsVM = _.get(pupModel, 'coverables.locations');
    const pupVehiclesVM = _.get(pupModel, 'coverables.vehicles');
    const [isGroupAvailable, setIsGroupAvailable] = useState(undefined);
    const [isRequestInProgress, setIsRequestInProgress] = useState(false);
    const [vinErrorCheck, updateVinErrorCheck] = useState(undefined);

    let nextID = 0;
    let removedWatercraft;
    let removedWatercraftOperator;

    let wizardConfig;
    if (isAmpMode) {
        if (isPersonalAuto) {
            wizardConfig = ampPaWizardConfig;
        } else if (isHomeowners) {
            wizardConfig = ampHoWizardConfig;
        } else {
            wizardConfig = ampPupWizardConfig;
        }
    } else {
        // eslint-disable-next-line no-lonely-if
        if (isPersonalAuto) {
            wizardConfig = paWizardConfig;
        } else if (isHomeowners) {
            wizardConfig = hoWizardConfig;
        } else {
            wizardConfig = pupWizardConfig;
        }
    }
    const { steps } = wizardConfig;

    const [saveOnAdditionalChange, setSaveOnAdditionalChange] = useState(false);
    const [missingVehicleOnPolicy, setMissingVehicleOnPolicy] = useState(false);
    const [addedNonOwnedVehicle, setAddedNonOwnedVehicle] = useState(viewModelService.create({}, 'pc', 'edge.capabilities.policyjob.lob.personalauto.coverables.dto.VehicleDTO'))
    const [fixedDriverIds, setFixedDriverIds] = useState([]);
    const [showErrorMessagetoAddInterestedParty, setShowErrorMessagetoAddInterestedParty] = useState(false);
    const {
        getVehicleDiscountMessage,
        isDriverHousehold
    } = MLDriverVehicleUtil();

    function isInFlowHistory(mlStepName) {
        return currentSteps.some((step) => step.mlStepName === mlStepName && !!step.visited);
    }

    useEffect(() => {
        if (isAgent) {
            PolChangeTrackEvent('Endorsement Step Reached', false, submissionVM, authHeader, { step: 'PolChange Additional Changes Screen' });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if((additionalPolicyChangeProps.isPolicyChangeAndTrasferToPayrollFlow !== true) && (isPersonalAuto || isHomeowners || isPersonalUmbrella)) {
            setUpdatedSteps(steps.filter(step => step.mlStepName !== "endorsementTrasferToPayroll"));
        }
        else {
        setUpdatedSteps(steps);
        }
    },[]);

    const getGroupSettings = useCallback(() => {
        return MLStateRolloutService.checkIsGroupEnabled(submissionVM.baseData?.value?.policyAddress.state, authHeader)
    }, [authHeader, submissionVM.baseData?.value?.policyAddress.state]);

    const updateDynamicStartingPoint = useCallback((step) => {
        if ((isPersonalAuto && step.mlStepName === 'endorsementPaListExcludedDrivers') || (isPersonalUmbrella && step.mlStepName === 'endorsementPupListExcludedVehicleOperators')) {
            step.stepProps.isStartingPointML = submissionVM.baseData.value.canExcludeDrivers_ML;
        }

        if (!isModernProduct && step.mlStepName === 'endorsementPaListRentedTrailerCamper') {
            step.stepProps.isStartingPointML = false;
        }

        if (isHomeowners && step.mlStepName === 'endorsementHoPropertyDetails') {
            const coveragePartType = _.get(submissionVM, 'lobData.homeowners.coverables.coveragePartType_ML.value.code');
            if (coveragePartType !== 'hoprental') {
                step.stepProps.isStartingPointML = true;
            } else {
                step.stepProps.isStartingPointML = false;
            }
        }

        if (_.isUndefined(isGroupAvailable && !isRequestInProgress)) {
            setIsRequestInProgress(true);
            let promise = getGroupSettings();
            promise.then((isGroupEligible) => {
                steps.forEach((step) => {
                    if ((isPersonalAuto && step.mlStepName === 'endorsementPaGroupAssociations') || (isPersonalUmbrella && step.mlStepName === 'endorsementPupGroupAssociations')
                        || (isHomeowners && step.mlStepName === 'endorsementHoGroupAssociations')) {
                      isGroupEligible = submissionVM?.baseData?.producerCodeOfService_ML?.producerType_ML?.value?.code === "ia" ? false : isGroupEligible
                      step.stepProps.isStartingPointML = isGroupEligible;
                        setIsGroupAvailable(isGroupEligible);
                    }
                });
            })
                .finally(() => {
                    setIsRequestInProgress(false);
                });
        }
    }, [getGroupSettings, isGroupAvailable, isHomeowners, isPersonalAuto, isPersonalUmbrella, isRequestInProgress, steps, submissionVM]);

    const availableAddlChanges = useMemo(() => {
        const filteredSteps = updatedSteps.filter((step) => {
            updateDynamicStartingPoint(step);

            if (_.get(step, 'stepProps.isStartingPointML', false)) {
                step.label = step.stepProps.stepButtonLabelML ? translator(step.stepProps.stepButtonLabelML) : translator(step.title);
                if(step.mlStepName == "endorsementPupListNonDrivingVehicleOperators" && isUMB_NP) {
                    step.label = 'Non Drivers'
                }
                return true;
            }
            return false;
        });
        return _.orderBy(filteredSteps, 'label');
    }, [updatedSteps, translator, updateDynamicStartingPoint]);

    const updateWizardSubmissionData = useCallback((vm) => {
        _.set(wizardData, 'submissionVM', vm);
        updateWizardData(wizardData);
    }, [updateWizardData, wizardData]);

    const getTypeKeyDescription = useCallback((typeKeyName) => {
        return translator({
            id: typeKeyName,
            defaultMessage: typeKeyName
        });
    }, [translator]);

    const getBodyTypeValue_Ext = (bodyType) => {
        if (!_.isUndefined(bodyType)) {
            const { name } = BODYTYPE_TYPELIST.getCode(bodyType);
            return getTypeKeyDescription(name);
        }
        return '';
    };

    const wasEndorsementQuoteDetailsInVisitedSteps = isInFlowHistory(endorsementQuoteDetails);

    const removeMessage = (message, shouldRemove) => {
        if (shouldRemove) {
            const idx = _.indexOf(alertMessages, message);
            if (idx >= 0) {
                alertMessages.splice(idx, 1);
            }
        }
    };

    const addAlertMessage = (alertType, alertMessage, alertName, undoFunction, help) => {
        const isUniqueAlert = alertMessages.filter((alert) => alert.message === alertMessage).length === 0;
        if (isUniqueAlert) {
            if (undoFunction) {
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                alertMessage = (
                    <React.Fragment>
                        {alertMessage}<a role="button" tabIndex={0} onClick={undoFunction} onKeyDown={undoFunction}>{translator(messages.undo)}</a>
                    </React.Fragment>
                )
            }
            let alertFunc;
            if (alertType === 'success') {
                alertFunc = addSuccessAlert;
            } else if (alertType === 'error') {
                alertFunc = addErrorAlert;
            } else if (alertType === 'warning') {
                alertFunc = addWarningAlert;
            } else {
                alertFunc = addSuccessAlert;
            }
            const alertHelpTitle = help && help.title;
            const alertHelpMessage = help && help.message;

            alertFunc(alertMessage, alertName, undoFunction, alertHelpTitle, alertHelpMessage);
        }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const showChangesAlerts = (shouldRemoveMessage = true) => {
        clearAlerts();
        if (alertMessages && alertMessages.length > 0) {
            alertMessages.forEach((alert) => {
                if (alert.alertName && (alert.message || alert.formattedMessageName)) {
                    let alertMessage;
                    const alertType = alert.type ? alert.type : 'success';
                    if (alert.message) {
                        alertMessage = alert.additionalMessage ? `${alert.message} ${alert.additionalMessage}` : alert.message;
                    } else if (alert.formattedMessageName) {
                        alertMessage = (
                            <FormattedMessage
                                {...messages[alert.formattedMessageName]}
                                values={{
                                    strongName: <strong>{alert.messagePram}</strong>
                                }}
                            />
                        );
                    }

                    addAlertMessage(alertType, alertMessage, alert.alertName, alert.actionFn, alert.help)
                    removeMessage(alert, shouldRemoveMessage);
                }
            });
        }
    };
    const undoAdditionOfNonOwnedVehicle = () => {
        if (addedNonOwnedVehicle) {
            paCoverableVal.removeVehicle(addedNonOwnedVehicle);
        }
        // setAddedNonOwnedVehicle(viewModelService.create({}, 'pc', 'edge.capabilities.policyjob.lob.personalauto.coverables.dto.VehicleDTO'));
    };

    const undoVehicleRemoval = (selectedVehiclesVM, removedVehicle) => {
        selectedVehiclesVM.pushElement(removedVehicle);
        if (isPersonalAuto) {
            undoAdditionOfNonOwnedVehicle();
        }

        setSaveOnAdditionalChange(false);
        alertMessages.pop();
        clearAlerts();
    }

    const showChangesAlertForRemoveVehicle = (shouldRemoveMessage = true) => {
        clearAlerts();
        if (alertMessages && alertMessages.length > 0) {
            alertMessages.forEach((alert) => {
                addSuccessAlert({
                    ...messages[alert.formattedMessageName], args: {
                        strongName: (<strong>{alert.messagePram}</strong>),
                        linebreak: <br />,
                        nextline: alert.additionalMessage
                    }
                }, null, alert.actionFn, null, null, true)
                removeMessage(alert, shouldRemoveMessage);

            })
        }
    }

    const isVinDuplicated = (vehicleVM) => {
        if (!currentLob.coverables.vehicles || !currentLob.coverables.vehicles.value) {
            return false;
        }
        const vehicleVin = vehicleVM.vin || vehicleVM.vIN;
        if (vehicleVin.value === undefined) {
            return false;
        }
        const vehicleList = currentLob.coverables.vehicles.value;
        const vehiclesWithTheSameVin = vehicleList.filter((x) => (x.vin || x.vIN) === vehicleVin.value);
        return vehiclesWithTheSameVin.length >= 2;
    };

    const _findVehicleElement = (vehicle) => {
        return currentLob.coverables.vehicles.children.find((vhc) => vhc.value === vehicle);
    };


    const _saveToEndorsement = () => {
        const promise = EndorsementService.saveEndorsement([submissionVM.value], authHeader);
        showProgressDialog(messages.savingEndorsement, promise)
        return promise;
    };

    const removeAlert = (alertName) => {
        const index = alertMessages.findIndex((alert) => alert.alertName === alertName);
        if (index >= 0) {
            alertMessages.splice(index, 1);
            showChangesAlerts();
        }
    };

    const createVehicleListModal = (paModelVM) => {

        const newStepID = 'endorsementPaVehicles';

        const onVehicleEdit = (item, onCancel) => {
            MLPolicyChangeDataHolderService.setPageAction('edit');
            // item.value.isSelected = true;
            item.isSelected = true;
            item.isReplacing = false;
            item.error = {
                message: undefined
            }
            onCancel();
            MLEndorsementFlowUtil.addAndNavigateToSelectedStep(newStepID, currentSteps, currentStepIndex, changeNextSteps, goNext, productCode);
        }

        const handleNonOwnedVehicleAdditionalAndRemoval = () => {
            if (isPersonalAuto) {
                const vehicles = currentLob.coverables.value.vehicles;
                if (vehicles.length === 0) {
                    // setAddedNonOwnedVehicle(paCoverableVal.createVehicle());
                    addedNonOwnedVehicle.namedNonOwner_ML = true;
                    addedNonOwnedVehicle.costNew = {
                        amount: 0
                    };
                    addedNonOwnedVehicle.additionalInterests = [];
                } else {
                    const nonOwnerVehicle = vehicles.find((veh) => veh.namedNonOwner_ML && veh.namedNonOwner_ML === true);
                    if (nonOwnerVehicle) {
                        paCoverableVal.removeVehicle(nonOwnerVehicle.value);
                    }
                }
            }
        }

        const openAddModal = (vehicleVM, replacedVehicle) => {

            const onCancelAddVehicle = () => {
                if (replacedVehicle) {
                    vehiclesVM.value.push(replacedVehicle);
                    removeAlert(alertNames.replacedVehicleName)
                }
                currentLob.coverables.value.removeVehicle(vehicleVM.value);
                return true;
            }

            const onSaveValidation = () => {
                const categoriesWithoutVin = ['low_speed_vehicle', 'registered_golf_cart', 'trailer'];
                if (categoriesWithoutVin.includes(vehicleVM.value.category_ML)) {
                    vehicleVM.vin = undefined;
                }

                if (isVinDuplicated(vehicleVM)) {
                    return translator(messages.duplicatedVinFlag);
                }

                return true;
            }

            const saveVehicleToEndorsement = () => {
                const vehiclesWithFixedId = submissionVM.lobData.personalAuto.coverables.vehicles.value.filter((vehicle) => !!vehicle.fixedId);
                return _saveToEndorsement().then((policyChangeDTO) => {
                    const policyChange = new PolicyChange(policyChangeDTO);
                    const updatedEndorsementVM = viewModelService.create(policyChange, 'pc', 'edge.capabilities.policychange.dto.PolicyChangeDataDTO');

                    const currentVehicles = updatedEndorsementVM.lobData.personalAuto.coverables.vehicles.value;
                    const updatedModalVehicle = currentVehicles.find((vehicle) => {
                        const matchesModalVehicle = vehicle.fixedId === vehicleVM.value.fixedId;
                        const isNewVehicle = !vehiclesWithFixedId.some((v) => v.fixedId === vehicle.fixedId);
                        return matchesModalVehicle || isNewVehicle;
                    });

                    MLPolicyChangeDataHolderService.setVehicle(updatedModalVehicle);

                    const stepId = updatedEndorsementVM.lobData.personalAuto.value ? 'endorsementPaVehicles' : 'endorsementPupVehicles';
                    updateWizardSubmissionData(updatedEndorsementVM);

                    updatedEndorsementVM.value.stayOnStepML = true;
                    MLEndorsementFlowUtil.addAndNavigateToSelectedStep(stepId, currentSteps, currentStepIndex, changeNextSteps, goNext, productCode);

                    const action = updatedModalVehicle.isReplacing ? 'Replace' : 'Add';
                    MLTagManagerService.sendFormStepEvent(MLTagManagerService.getFormName(), `${MLTagManagerService.getStepName()}_${action} Vehicle`);
                    return true;
                }).catch((e) => {
                    return e.baseError;
                });
            };

            const title = replacedVehicle ? messages.replaceVehicle : messages.addVehicle
            const alerts = []

            if (replacedVehicle) {
                alerts.push({
                    type: "success",
                    block: alertNames.replacedVehicleName,
                    message: translator(messages.vehicleReplaced, {
                        strong: (chunks) => <strong>{chunks}</strong>,
                        vehicleName: vehicleVM.value.orgVehicleName
                    })
                })
            }

            const componentProps = {
                title,
                subtitle: newVehiclePopupMessages.quoteInfomayChange,
                CustomComponent: MLPartialVehicleDetailsComponent,
                viewModelService,
                viewModel: vehicleVM,
                showFooterOnCustomComponent: true,
                onSaveAction: onSaveValidation,
                actionBtnLabel: translator(messages.continue),
                messageNextToButton: (<FormattedMessage
                    {...newVehiclePopupMessages.nextWellAddDetails}
                    values={{
                        addRemainingDetails: <strong>{translator(newVehiclePopupMessages.addRemainingDetails)}</strong>
                    }}
                />),
                showValidationMessage: true,
                overrideProps: {
                    submissionVM: submissionVM,
                    showProgressDialog,
                    hideProgressDialog,
                    isCompRaterQuote: false,
                    updateVinErrorCheck,
                    vinErrorCheck,
                }
            };

            modalApi.showModal(
                <FormModalPopover {...componentProps} />
            ).then(saveVehicleToEndorsement).catch(onCancelAddVehicle);
        }

        const onVehicleAdd = (onCancel) => {
            MLPolicyChangeDataHolderService.setPageAction('add');
            const getNNOVehicleIndex = submissionVM.lobData.personalAuto.coverables.vehicles.value.findIndex(
                (vhc) => vhc.namedNonOwner_ML === true);
            if (getNNOVehicleIndex !== -1) {
                const updateVehicle = _.cloneDeep(submissionVM.lobData.personalAuto.coverables.vehicles);
                updateVehicle.value[getNNOVehicleIndex].parkedAtPrimary_ML = true;
                updateVehicle.value[getNNOVehicleIndex].category_ML = 'private_passenger_light_truck';
                updateVehicle.value[getNNOVehicleIndex].isSelected = true;
                updateVehicle.value[getNNOVehicleIndex].isReplacing = false;
                updateVehicle.value[getNNOVehicleIndex].namedNonOwner_ML = false;
                updateVehicle.value[getNNOVehicleIndex].error = {
                    message: undefined
                };
            } else {
                MLPolicyChangeDataHolderService.setPageAction('add');
                const vehicle = paCoverableVal.createVehicle();
                vehicle.parkedAtPrimary_ML = true;
                vehicle.category_ML = 'private_passenger_light_truck';
                vehicle.isSelected = true;
                vehicle.isReplacing = false;
                vehicle.namedNonOwner_ML = false;
                vehicle.error = {
                    message: undefined
                };
            }

            handleNonOwnedVehicleAdditionalAndRemoval();
            updateWizardSubmissionData(submissionVM);

            if (isAmpMode) {
                const vehicle = paCoverableVal.createVehicle();
                vehicle.editMode_ML = true;
                vehicle.partialAddMode_Ext = true;
                // Not part of the original code, workaround for using the wrong vehicle DTO
                vehicle.primaryUse = "school_or_work_ml";
                vehicle.ownedLessThan6Months_Ext = true;
                vehicle.parkingType_ML = "garage";
                vehicle.purchaseDate_ML = LocalDateUtil.today();
                vehicle.financeCategory_ML = "owned";
                vehicle.annualMileage = 0;
                // End workaround
                openAddModal(_findVehicleElement(vehicle));
            } else {
                MLEndorsementFlowUtil.addAndNavigateToSelectedStep(newStepID, currentSteps, currentStepIndex, changeNextSteps, goNext, productCode);
                onCancel();
            }
        };

        const parameterStringBuidler_Ext = (item) => {
            const trim = item.trim_ML || '';
            const bodyType = getBodyTypeValue_Ext(item.bodyType_ML);
            return _.trim(`${item.displayName} ${trim} ${bodyType}`);
        };

        const getRemovedVehicleMessage = () => {
            if (submissionVM.lobData.personalAuto.value && currentLob.coverables.value.vehicles.length === 0) {
                return translator(messages.vehicleAdditionalMessages)
            }
            return undefined

        }

        const onVehicleRemove = (item, onCancel) => {
            MLPolicyChangeDataHolderService.setPageAction('remove');
            const removedVehicle = _.cloneDeep(item.value);
            const dynamicStepLabel = `${item.value.year} ${item.value.make} ${item.value.model}`;
            paCoverableVal.removeVehicle(item.value);
            const alert = {
                alertName: alertNames.removedVehicleName,
                formattedMessageName: 'vehicleHasBeenRemoved',
                messagePram: parameterStringBuidler_Ext(removedVehicle),
                actionText: translator(messages.undo),
                additionalMessage: getRemovedVehicleMessage(),
                actionFn: () => undoVehicleRemoval(vehiclesVM, removedVehicle)
            }

            // empty alertMessages and add a new alertMessage
            alertMessages.splice(0, alertMessages.length)
            alertMessages.push(alert)

            handleNonOwnedVehicleAdditionalAndRemoval();
            updateWizardSubmissionData(submissionVM);

            setSaveOnAdditionalChange(true)

            MLNavigationStepsTrackingService.addToDynamicSteps(
                translator(messages.removeVehicle), !currentStep.existingStep, currentStep.mlStepName, authHeader);
            onCancel();
            showChangesAlertForRemoveVehicle();

            const details = {
                data: dynamicStepLabel,
                fixedId: removedVehicle.fixedId,
                pageAction: MLPolicyChangeDataHolderService.getPageAction()
            };

            MLNavigationStepsTrackingService.completeCurrentStep(details, authHeader);
        };

        const onVehicleReplace = (vehicle, onCancel) => {
            MLPolicyChangeDataHolderService.setPageAction('replace');

            const removedReplacingVehicleName = _.cloneDeep(vehicle.displayName.value)
            const origVehicle = vehicle.value;

            MLPolicyChangeDataHolderService.setReplacedFixedId(origVehicle.fixedId);

            paCoverableVal.removeVehicle(vehicle.value);

            const alert = {
                alertName: alertNames.replacedVehicleName,
                formattedMessageName: 'vehicleReplaced',
                messagePram: removedReplacingVehicleName,
            };
            alertMessages.push(alert)

            vehicle = paCoverableVal.createVehicle();

            vehicle.isSelected = true;
            vehicle.isReplacing = true;
            vehicle.parkedAtPrimary_ML = true;
            vehicle.orgVehicleName = removedReplacingVehicleName
            vehicle.error = {
                message: undefined
            };

            if (isAmpMode) {
                vehicle.editMode_ML = true;
                vehicle.partialAddMode_Ext = true;
                // Not part of the original code, workaround for using the wrong vehicle DTO
                vehicle.primaryUse = "school_or_work_ml";
                vehicle.ownedLessThan6Months_Ext = true;
                vehicle.parkingType_ML = "garage";
                vehicle.purchaseDate_ML = LocalDateUtil.today();
                vehicle.financeCategory_ML = "owned";
                vehicle.annualMileage = 0;
                // End workaround
                openAddModal(_findVehicleElement(vehicle), origVehicle);
            } else {
                onCancel();
                MLEndorsementFlowUtil.addAndNavigateToSelectedStep(newStepID, currentSteps, currentStepIndex, changeNextSteps, goNext, productCode);
            }

        }

        const vehicleListPopUpComponentTitle = `${translator(messages.makeChanges)}`
        const componentProps = {
            title: vehicleListPopUpComponentTitle,
            CustomComponent: VehiclesListPopupComponent,
            overrideProps: {
                paModelVM: paModelVM,
                onVehicleAdd,
                onVehicleEdit,
                onVehicleRemove,
                onVehicleReplace,
                viewModelService,
                submissionVM
            }
        }

        Identify('Endorsement Step Reached', { step: 'Vehicles Screen' }, submissionVM, authHeader)

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        )
    }

    const onEditAlertMsg = () => {
        alertMessages.splice(0);
        showChangesAlerts();
    };

    const checkObjectValidity = (aVMListNode, nameOfFlag, valueOfFlag) => {
        if (aVMListNode && aVMListNode.children) {
            aVMListNode.children.forEach((aVMItem) => {
                aVMItem.value[nameOfFlag] = valueOfFlag;
                aVMItem.value.error = !(aVMItem.aspects.valid && aVMItem.aspects.subtreeValid);
            });
        }
    };

    const getDriverTypeDisplayName = (paramDriverType, isSingular) => {
        switch (paramDriverType) {
            case 'rated':
                return isSingular ? translator(messages.driver) : translator(messages.drivers);
            case 'excluded':
                return isSingular ? translator(messages.excludedDriver) : translator(messages.excludedDrivers);
            case 'household':
                if (isModernProduct) {
                    return isSingular ? translator(messages.nonDriver) : translator(messages.nonDrivers);
                } else {
                    return isSingular ? translator(messages.householdMember) : translator(messages.householdMembers);
                }
            default:
                return '';
        }
    };

    const getCurrentUlPolicyVM = (lobVM, isNewULPolicy) => {
        if (lobVM.personalUmbrella) {
            let index = -1;
            if (isNewULPolicy === true) {
                index = lobVM.personalUmbrella.underlyingPolicies.value.findIndex((ul) => ul.tempID);
            } else {
                index = lobVM.personalUmbrella.underlyingPolicies.value.findIndex((ul) => ul.isSelected);
            }
            return lobVM.personalUmbrella.underlyingPolicies.getElement(index);
        }
    };

    const updateDrivers = (driverType) => {
        const driversVM = _.get(currentLob, 'coverables.drivers');
        const index = driversVM.value.findIndex((driver) => !driver.fixedId);
        if (index > -1) {
            driversVM.value.pop(index);
        }

        setFixedDriverIds([]);
        const returnableDrivers = driversVM.value.filter((driver) => {
            if (driver.fixedId) {
                setFixedDriverIds([...fixedDriverIds, driver.fixedId]);
            }
            if (driverType === 'household' && isModernProduct) {
                return isDriverHousehold(driver);
            }
            return driver.type_ML === driverType;
        });
        return returnableDrivers;
    };

    const openDriverModal = (driverType, wizardStepID) => { 
    const hiddenRemovalStatuses = ['unknown', 'not_household', 'notresiding'];

    const drivers = updateDrivers(driverType).filter((driver) => {
        const status = _.get(driver, 'status_ML') || _.get(driver, 'value.status_ML');
        if (isModernProduct && hiddenRemovalStatuses.includes(status)) {
            return false;
        }
        return true;
    });
 
        const addDriver = (onCancel) => {
            MLPolicyChangeDataHolderService.setPageAction('add');
            MLPolicyChangeDataHolderService.setDriverType(driverType);
            onCancel();
            MLEndorsementFlowUtil.addAndNavigateToSelectedStep(wizardStepID, currentSteps, currentStepIndex, changeNextSteps, goNext, productCode);
        };

        const editDriver = (item, onCancel) => {
            item.isSelected = true;
            MLPolicyChangeDataHolderService.setPageAction('edit');
            MLPolicyChangeDataHolderService.setDriverType(driverType);
            onCancel();
            MLEndorsementFlowUtil.addAndNavigateToSelectedStep(wizardStepID, currentSteps, currentStepIndex, changeNextSteps, goNext, productCode);
    };

        const removeDriver = (item, onCancel) => {
            item.isSelected = true;
            MLPolicyChangeDataHolderService.setPageAction('remove');
            MLPolicyChangeDataHolderService.setDriverType(driverType);
            onCancel();
            MLEndorsementFlowUtil.addAndNavigateToSelectedStep(wizardStepID, currentSteps, currentStepIndex, changeNextSteps, goNext, productCode);
        };

        const componentProps = {
            title: translator(messages.makeChanges),
            overrideProps: {
                submissionVM,
                driverType,
                drivers,
                onAddDriver: addDriver,
                onEditDriver: editDriver,
                onRemoveDriver: removeDriver,
                viewModelService,
                authHeader,
                showProgressDialog,
                EndorsementService
            },
            CustomComponent: MLDriverChangeTablePopup,
            showFooterOnCustomComponent: false,
            additionalPEStyle: 'customFooterModal'
        };

        Identify('Endorsement Step Reached', { step: `${driverType} Drivers Screen` }, submissionVM, authHeader)

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    };

    const openDriverDiscoveryReviewModal = (wizardStepID) => {
        const prefillDrivers = _.get(submissionVM, 'lobData.personalAuto.coverables.prefillDrivers.value')
        const discoveredDrivers = prefillDrivers.filter((driver) => driver.reportType === 'discovery')
        const nonDiscoveredDrivers = prefillDrivers.filter((driver) => driver.reportType !== 'discovery')
        const componentProps = {
            title: translator(messages.makeChanges),
            overrideProps: {
                submissionVM,
                updateWizardData: updateWizardSubmissionData,
                wizardStepID,
                discoveredDrivers,
                nonDiscoveredDrivers,
                viewModelService,
                authHeader,
                showProgressDialog,
                saveToEndorsement
            },
            CustomComponent: MLDriverDiscoveryReviewTablePopup,
            showFooterOnCustomComponent: false,
            additionalPEStyle: 'customFooterModal'
        };


        Identify('Endorsement Step Reached', { step: 'Driver Discovery Screen' }, submissionVM, authHeader)

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    };

    const openWatercraftModal = () => {
        const wcStepID = 'endorsementPupWatercraft';
        const wcoStepID = 'endorsementPupWatercraftOperator';

        const addWatercraft = (onCancel) => {
            MLPolicyChangeDataHolderService.setPageAction('add');
            watercraftsVM.value.forEach((watercraft) => {
                delete watercraft.isSelected;
            });

            const newWatercraft = {
                tempID: nextID++
            };

            const newWatercraftVM = viewModelService.create(newWatercraft, 'pc', 'metlife.edge.capabilities.common.plugin.dto.PUPWatercraftDTOML');
            watercraftsVM.value.push(newWatercraftVM.value);
            newWatercraftVM.value.isSelected = true;
            MLEndorsementFlowUtil.addAndNavigateToSelectedStep(wcStepID, currentSteps, currentStepIndex, changeNextSteps, goNext, productCode);
            onCancel();
        };

        const editWatercraft = (item, onCancel) => {
            MLPolicyChangeDataHolderService.setPageAction('edit');
            watercraftsVM.value.forEach((watercraft) => {
                delete watercraft.isSelected;
            });

            item.isSelected = true;
            // onEditAlertMsg();
            MLEndorsementFlowUtil.addAndNavigateToSelectedStep(wcStepID, currentSteps, currentStepIndex, changeNextSteps, goNext, productCode);
            onCancel();
        };

        const undoWatercraftRemoval = () => {
            watercraftsVM.value.push(removedWatercraft);
            _.set(wizardData, 'alertMessages', []);
            removedWatercraft = {};
            showChangesAlerts();
        };

        const removeWatercraft = (item, onCancel) => {
            MLPolicyChangeDataHolderService.setPageAction('remove');
            removedWatercraft = item;

            const removedWatercraftCode = item.watercraftType;
            const availableWatercraftTypes = _.get(watercraftsVM, 'children[0].watercraftType.aspects.availableValues',[]);
 
            const removedWatercraftTypeOption = availableWatercraftTypes.find(
                (type)=> type.code === removedWatercraftCode
            )

            const watercraftTypeName = removedWatercraftTypeOption
            ? translator({id: removedWatercraftTypeOption.name, defaultMessage: removedWatercraftTypeOption.name})    
            : watercraftTypeCode;


            const index = watercraftsVM.value.findIndex((ba) => ba === item);
            if (index >= 0) {
                watercraftsVM.value.splice(index, 1);
            }

            const alert = {
                alertName: alertNames.removedWatercraftName,
                formattedMessageName: 'watercraftXHasBeenRemoved',
                messagePram: `${removedWatercraft.year} ${watercraftTypeName} `,
                actionFn: undoWatercraftRemoval
            };
            _.set(wizardData, 'alertMessages', []);
            alertMessages.push(alert);
            showChangesAlerts();
            MLNavigationStepsTrackingService.addToDynamicSteps(translator(messages.removeWatercraft), false, currentStep.mlStepName, authHeader);
            onCancel();
            MLNavigationStepsTrackingService.completeCurrentStep(`${removedWatercraft.year} ${removedWatercraft.make} ${removedWatercraft.model}`, authHeader);
        };

        const addWatercraftOperator = (item, onCancel) => {
            MLPolicyChangeDataHolderService.setPageAction('add');
            watercraftOperatorsVM.value.forEach((watercraftOperator) => {
                delete watercraftOperator.isSelected;
            });
            item.value.isSelected = true;
            watercraftOperatorsVM.value.push(item.value);
            MLEndorsementFlowUtil.addAndNavigateToSelectedStep(wcoStepID, currentSteps, currentStepIndex, changeNextSteps, goNext, productCode);
            onCancel();
        };

        const editWatercraftOperator = (item, onCancel) => {
            MLPolicyChangeDataHolderService.setPageAction('edit');
            watercraftOperatorsVM.value.forEach((watercraftOperator) => {
                delete watercraftOperator.isSelected;
            });

            item.value.isSelected = true;
            // onEditAlertMsg();
            MLEndorsementFlowUtil.addAndNavigateToSelectedStep(wcoStepID, currentSteps, currentStepIndex, changeNextSteps, goNext, productCode);
            onCancel();
        };

        const undoWatercraftOperatorRemoval = () => {
            watercraftOperatorsVM.value.push(removedWatercraftOperator);
            _.set(wizardData, 'alertMessages', []);
            removedWatercraftOperator = {};
            showChangesAlerts();
        };

        const removeWatercraftOperator = (item, onCancel) => {
            MLPolicyChangeDataHolderService.setPageAction('remove');
            removedWatercraftOperator = item;
            item.fixedID = null;

            const index = watercraftOperatorsVM.value.findIndex((ba) => ba === item);
            if (index >= 0) {
                addRemovedWatercraftOperatorToAvailableCandidates(submissionVM, item);
                watercraftOperatorsVM.value.splice(index, 1);
            }

            const alert = {
                alertName: alertNames.removedWatercraftOperatorName,
                formattedMessageName: 'watercraftOperatorXHasBeenRemoved',
                messagePram: `${removedWatercraftOperator.contact.fullName}`,
                actionFn: undoWatercraftOperatorRemoval
            };
            _.set(wizardData, 'alertMessages', []);
            alertMessages.push(alert);
            showChangesAlerts();
            MLNavigationStepsTrackingService.addToDynamicSteps(translator(messages.removeWatercraftOperator), false, currentStep.mlStepName, authHeader);
            onCancel();
        };

        const componentProps = {
            title: translator(messages.makeChanges),
            overrideProps: {
                submissionVM,
                isPolicyChange: true,
                updateWizardData: updateWizardSubmissionData,
                addWatercraft,
                editWatercraft,
                removeWatercraft,
                addWatercraftOperator,
                editWatercraftOperator,
                removeWatercraftOperator,
            },
            CustomComponent: MLWatercraftListPopup,
            viewModelService,
            showFooterOnCustomComponent: true,
            actionBtnLabel: translator(messages.continue),
            closeSimpleMessage: true,
            showBannerMessage: true,
            additionalPEStyle: 'customFooterModal'
        };

        Identify('Endorsement Step Reached', { step: 'Watercraft Screen' }, submissionVM, authHeader)

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    };


    const openBusinessActivityModal = () => {
        const newStepID = 'endorsementPupBusinessActivity';

        const addBusActivity = (onCancel) => {
            MLPolicyChangeDataHolderService.setPageAction('add');
            businessActivitiesVM.value.forEach((busActivity) => {
                delete busActivity.isSelected;
            });

            const newBusActivity = {
                tempID: nextID++
            };

            const newBusActivityVM = viewModelService.create(newBusActivity, 'pc', 'metlife.edge.capabilities.common.plugin.dto.PUPBusinessActivityDTOML');
            businessActivitiesVM.value.push(newBusActivityVM.value);
            newBusActivityVM.value.isSelected = true;
            onCancel();
            MLEndorsementFlowUtil.addAndNavigateToSelectedStep(newStepID, currentSteps, currentStepIndex, changeNextSteps, goNext, productCode);
        };

        const editBusActivity = (item, onCancel) => {
            MLPolicyChangeDataHolderService.setPageAction('edit');
            businessActivitiesVM.value.forEach((busActivity) => {
                delete busActivity.isSelected;
            });

            item.isSelected = true;
            onEditAlertMsg();
            onCancel();
            MLEndorsementFlowUtil.addAndNavigateToSelectedStep(newStepID, currentSteps, currentStepIndex, changeNextSteps, goNext, productCode);
        };

        const undoBizActivityRemoval = (removedBizActivity) => {
            businessActivitiesVM.value.push(removedBizActivity);
            alertMessages.splice(0);
            showChangesAlerts();
        };

        const removeBusActivity = (item, onCancel) => {
            MLPolicyChangeDataHolderService.setPageAction('remove');
            const removedBizActivity = _.cloneDeep(item);

            const index = businessActivitiesVM.value.findIndex((ba) => ba === item);
            if (index >= 0) {
                businessActivitiesVM.value.splice(index, 1);
            }

            if (removedBizActivity.name) {
                const alert = {
                    alertName: alertNames.removedBizActivityName,
                    formattedMessageName: 'businessActivityXHasBeenRemoved',
                    messagePram: removedBizActivity.name,
                    actionFn: () => undoBizActivityRemoval(removedBizActivity)
                };
                alertMessages.splice(0);
                alertMessages.push(alert);
                showChangesAlerts();
            } else if(isUMB_NP && removedBizActivity.businessClass === "ExcessChdCare") {
                const alert = {
                    alertName: alertNames.removedBizActivityName,
                    formattedMessageName: 'businessActivityHasBeenRemoved',
                    actionFn: () => undoBizActivityRemoval(removedBizActivity)
                };
                alertMessages.splice(0);
                alertMessages.push(alert);
                showChangesAlerts();
            }
            MLNavigationStepsTrackingService.addToDynamicSteps(translator(messages.removeBusinessActivity), false, currentStep.mlStepName, authHeader);
            onCancel();
            MLNavigationStepsTrackingService.completeCurrentStep(item.name, authHeader);
        };

        const hasErrors = () => {
            return businessActivitiesVM.value.filter((busActivity) => busActivity.error === true).length > 0;
        };

        const componentProps = {
            title: translator(messages.makeChanges),
            alertEntity: 'businessActivity',
            hasErrors: hasErrors(),
            onAddAction: addBusActivity,
            viewModelService,
            overrideProps: {
                submissionVM,
                editBusActivity,
                removeBusActivity
            },
            CustomComponent: MLBusinessActivitiesListPopup
        };

        Identify('Endorsement Step Reached', { step: 'Business Activity Screen' }, submissionVM, authHeader)

        modalApi.showModal(
            <MLModalWithAlerts {...componentProps} />
        );
    };

    const openPUPVehicleOperatorModal = (driverType, canExcludeDrivers) => {
        const newStepID = 'endorsementPupVehicleOperator';

        const index = vehicleOperatorsVM.value.findIndex((vo) => !vo.fixedID);
        if (index > -1) {
            vehicleOperatorsVM.value.pop(index);
        }

        const modalData = {
            vehicleOperators: vehicleOperatorsVM,
            driverType,
            canExcludeDrivers
        };

        const addVehicleOperator = (onCancel) => {
            MLPolicyChangeDataHolderService.setPageAction('add');
            let canAddSpouse = true;
            vehicleOperatorsVM.value.forEach((vehicleOperator) => {
                delete vehicleOperator.isSelected;

                if (vehicleOperator.relationshipToInsured === 'spouse') {
                    canAddSpouse = false;
                }
            });

            const newVehicleOperator = {
                contact: new Contact(),
                driverType
            };

            const vehicleOperatorVM = viewModelService.create(newVehicleOperator, 'pc', 'metlife.edge.capabilities.common.plugin.dto.PUPVehicleOperatorDTOML');
            vehicleOperatorsVM.value.push(vehicleOperatorVM.value);
            vehicleOperatorVM.value.isSelected = true;
            vehicleOperatorVM.value.isToRemove = false;
            vehicleOperatorVM.value.canAddSpouse = canAddSpouse;
            
            if(isUMB_NP && driverType === 'household' ) {
                vehicleOperatorVM.value.driverType = "nondriver";
            } else{
                vehicleOperatorVM.value.driverType = driverType;
            }

            if (driverType === 'rated') {
                vehicleOperatorVM.value.contact.isDateOfBirthRequired = true;
                MLPolicyChangeDataHolderService.setDriver(vehicleOperatorVM.value);

                const onAdd = () => {
                    MLEndorsementFlowUtil.addAndNavigateToSelectedStep(newStepID, currentSteps, currentStepIndex, changeNextSteps, goNext, productCode);
                }

                const componentProps = {
                    title: translator(isAgent ? 'Add Driver' : 'Add a new driver'),
                    viewModelService,
                    authHeader,
                    overrideProps: {
                        submissionVM,
                        onCancel,
                        onAdd,
                        showProgressDialog,
                        EndorsementService
                    },
                    CustomComponent: MLAddVehicleOperatorPopup,
                    showFooterOnCustomComponent: false,
                    additionalPEStyle: 'customFooterModal'
                };

                modalApi.showModal(
                    <FormModalPopover {...componentProps} />
                );
            } else if (driverType === 'excluded') {
                vehicleOperatorVM.value.contact.isDateOfBirthRequired = true;
                MLPolicyChangeDataHolderService.setDriver(vehicleOperatorVM.value);
                MLEndorsementFlowUtil.addAndNavigateToSelectedStep(newStepID, currentSteps, currentStepIndex, changeNextSteps, goNext, productCode);
                onCancel();
            } else {
                vehicleOperatorVM.value.contact.isDateOfBirthForNonDriverRequired = true;
                MLPolicyChangeDataHolderService.setDriver(vehicleOperatorVM.value);
                MLEndorsementFlowUtil.addAndNavigateToSelectedStep(newStepID, currentSteps, currentStepIndex, changeNextSteps, goNext, productCode);
                onCancel();
            }
        };

        const editVehicleOperator = (item, onCancel) => {
            MLPolicyChangeDataHolderService.setPageAction('edit');
            let spouseExists = false;
            vehicleOperatorsVM.value.forEach((vehicleOperator) => {
                if (vehicleOperator.relationshipToInsured === 'spouse') {
                    spouseExists = true;
                }
            });

            vehicleOperatorsVM.value.forEach((vehicleOperator) => {
                delete vehicleOperator.isSelected;

                if (spouseExists) {
                    vehicleOperator.canAddSpouse = vehicleOperator.relationshipToInsured === 'spouse';
                } else {
                    vehicleOperator.canAddSpouse = true;
                }
            });

            item.isSelected = true;
            item.isToRemove = false;
            item.driverType = driverType;
            onEditAlertMsg();

            if (driverType === 'rated') {
                MLPolicyChangeDataHolderService.setDriver(item);
                const onAdd = () => {
                    MLEndorsementFlowUtil.addAndNavigateToSelectedStep(newStepID, currentSteps, currentStepIndex, changeNextSteps, goNext, productCode);
                }

                const componentProps = {
                    title: translator('Edit driver'),
                    overrideProps: {
                        submissionVM,
                        onCancel,
                        onAdd,
                        showProgressDialog,
                        EndorsementService
                    },
                    authHeader,
                    viewModelService,
                    CustomComponent: MLAddVehicleOperatorPopup,
                    showFooterOnCustomComponent: false,
                    additionalPEStyle: 'customFooterModal'
                };

                modalApi.showModal(
                    <FormModalPopover {...componentProps} />
                );
            } else {
                MLPolicyChangeDataHolderService.setDriver(item);
                MLEndorsementFlowUtil.addAndNavigateToSelectedStep(newStepID, currentSteps, currentStepIndex, changeNextSteps, goNext, productCode);
                onCancel();
            }
        };

        const removeVehicleOperator = (item, onCancel) => {
            MLPolicyChangeDataHolderService.setPageAction('remove');
            vehicleOperatorsVM.value.forEach((vehicleOperator) => {
                delete vehicleOperator.isSelected;
            });

            item.isSelected = true;
            item.isToRemove = true;
            if(!isUMB_NP) {
               item.driverType = driverType;
            }
            alertMessages.splice(0);
            showChangesAlerts();
            MLPolicyChangeDataHolderService.setDriver(item);
            MLEndorsementFlowUtil.addAndNavigateToSelectedStep(newStepID, currentSteps, currentStepIndex, changeNextSteps, goNext, productCode);
            onCancel();
        };

        const componentProps = {
            title: translator(messages.makeChanges),
            overrideProps: {
                modalData,
                addVehicleOperator,
                editVehicleOperator,
                removeVehicleOperator,
                getDriverTypeDisplayName,
                submissionVM,
            },
            CustomComponent: MLVehicleOperatorListPopup,
            viewModelService,
            showFooterOnCustomComponent: false,
            additionalPEStyle: 'customFooterModal'
        };

        Identify('Endorsement Step Reached', { step: 'Vehicle Operator Screen' }, submissionVM, authHeader)

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    };

    const openUnderlyingPolicyModal = () => {
        const newStepID = 'endorsementPupYourPolicy';

        const addUnderlyingPolicy = (onCancel) => {
            MLPolicyChangeDataHolderService.setPageAction('add');
            underlyingPoliciesVM.value.forEach((ulPolicy) => {
                delete ulPolicy.isSelected;
            });

            pupModel.value.createUnderlyingPolicy();
            const ulPolicyVM = getCurrentUlPolicyVM(submissionVM.lobData, true);
            ulPolicyVM.value.isSelected = true;
            removeAlert(alertNames.removedUnderlyingPolicyName);
            removeAlert(alertNames.addedUnderlyingPolicyName);
            onCancel();
            MLEndorsementFlowUtil.addAndNavigateToSelectedStep(newStepID, currentSteps, currentStepIndex, changeNextSteps, goNext, productCode);
        };

        const editUnderlyingPolicy = (item, onCancel) => {
            MLPolicyChangeDataHolderService.setPageAction('edit');
            underlyingPoliciesVM.value.forEach((ulPolicy) => {
                delete ulPolicy.isSelected;
            });

            item.isSelected = true;
            removeAlert(alertNames.removedUnderlyingPolicyName);
            removeAlert(alertNames.addedUnderlyingPolicyName);
            onCancel();
            MLEndorsementFlowUtil.addAndNavigateToSelectedStep(newStepID, currentSteps, currentStepIndex, changeNextSteps, goNext, productCode);
        };

        const undoUnderlyingPolicyRemoval = (removedUnderlyingPolicy) => {
            underlyingPoliciesVM.value.push(removedUnderlyingPolicy);
            removeAlert(alertNames.removedUnderlyingPolicyName);
            showChangesAlerts();
        };

        const getNameOfCarrier = (item) => {
            let carrier = null;
            if (item.carrier) {
                carrier = getTypeKeyDescription(CARRIER_TYPELIST.getCode(item.carrier).name);
                if (carrier === 'Other') {
                    carrier = item.otherCarrier;
                }
            }
            return carrier;
        };

        const removeUnderlyingPolicy = (item, onCancel) => {
            MLPolicyChangeDataHolderService.setPageAction('remove');
            const removedUnderlyingPolicy = _.cloneDeep(item);
            removeAlert(alertNames.removedUnderlyingPolicyName);
            removeAlert(alertNames.addedUnderlyingPolicyName);

            const index = underlyingPoliciesVM.value.findIndex((up) => up === item);
            if (index >= 0) {
                underlyingPoliciesVM.value.splice(index, 1);
            }

            const nameOfCareer = getNameOfCarrier(item);
            const nameOfPolicyType = item.policyType ? getTypeKeyDescription(POLICYTYPE_TYPELIST.getCode(item.policyType).name) : null;
            const alert = {
                alertName: alertNames.removedUnderlyingPolicyName,
                formattedMessageName: 'xHasBeenRemoved',
                messagePram: `${nameOfCareer} ${nameOfPolicyType}`,
                actionFn: () => undoUnderlyingPolicyRemoval(removedUnderlyingPolicy)
            };
            alertMessages.push(alert);
            showChangesAlerts();
            MLNavigationStepsTrackingService.addToDynamicSteps(translator(messages.removePolicy), false, currentStep.mlStepName, authHeader);
            onCancel();
            MLNavigationStepsTrackingService.completeCurrentStep(`${nameOfCareer} ${nameOfPolicyType}`, authHeader);
        };

        const hasErrors = () => {
            const hasUnselectedTerms = (ul) => {
                const coverages = _.get(ul, 'ulPolicyCoverage.coverages');
                return coverages && coverages.some((c) => c.terms.some((t) => t.chosenTerm === undefined));
            };
            return underlyingPoliciesVM.value.some((u) => u.error === true || hasUnselectedTerms(u));
        };

        const componentProps = {
            title: translator(messages.makeChanges),
            alertEntity: 'underlyingPolicy',
            hasErrors: hasErrors(),
            onAddAction: addUnderlyingPolicy,
            viewModelService,
            overrideProps: {
                underlyingPolicies: underlyingPoliciesVM.value,
                editUnderlyingPolicy,
                removeUnderlyingPolicy,
                isUMB_NP
            },
            CustomComponent: MLUnderlyingPoliciesListPopup
        };

        Identify('Endorsement Step Reached', { step: 'Underlying Policies Screen' }, submissionVM, authHeader)

        modalApi.showModal(
            <MLModalWithAlerts {...componentProps} />
        );
    };

    const openPUPLocationModal = () => {
        const newStepID = 'endorsementPupLocations';

        const addLocation = (onCancel) => {
            MLPolicyChangeDataHolderService.setPageAction('add');
            locationsVM.value.forEach((location) => {
                delete location.isSelected;
            });

            const newLocation = {
                tempID: nextID++,
                isFromPortal: true,
                isModernProduct: isModernProduct
            };

            const location = viewModelService.create(newLocation, 'pc', 'metlife.edge.capabilities.common.plugin.dto.PupLocationDTOML');
            locationsVM.value.push(location.value);
            location.value.isSelected = true;
            location.value.isInEditMode = false;
            onCancel();
            MLEndorsementFlowUtil.addAndNavigateToSelectedStep(newStepID, currentSteps, currentStepIndex, changeNextSteps, goNext, productCode);
        };

        const editLocation = (item, onCancel) => {
            MLPolicyChangeDataHolderService.setPageAction('edit');
            locationsVM.value.forEach((location) => {
                delete location.isSelected;
            });

            item.isSelected = true;
            item.isInEditMode = true;
            item.isModernProduct = isModernProduct;
            onEditAlertMsg();
            onCancel();
            MLEndorsementFlowUtil.addAndNavigateToSelectedStep(newStepID, currentSteps, currentStepIndex, changeNextSteps, goNext, productCode);
        };

        const undoLocationRemoval = (removedLocation) => {
            locationsVM.value.push(removedLocation);
            alertMessages.splice(0);
            showChangesAlerts();
        };

        const getFullAddress = (location) => {
            const address = location.address;
            return `
                ${address.addressLine1}
                ${address.addressLine2 ? address.addressLine2 : ''}
                ${address.city}
                ${address.state}
                ${address.postalCode}
            `;
        };

        const removeLocation = (item, onCancel) => {
            MLPolicyChangeDataHolderService.setPageAction('remove');
            const removedLocation = _.cloneDeep(item);
            const index = locationsVM.value.findIndex((lo) => lo === item);
            if (index >= 0) {
                locationsVM.value.splice(index, 1);
            }
            if (removedLocation.address.addressLine1) {
                const alert = {
                    alertName: alertNames.removedLocationName,
                    formattedMessageName: 'xLocationHasBeenRemoved',
                    messagePram: isAmpMode ? removedLocation.address.city : getFullAddress(removedLocation),
                    actionFn: () => undoLocationRemoval(removedLocation)
                };
                alertMessages.splice(0);
                alertMessages.push(alert);
                showChangesAlerts();
            }
            MLNavigationStepsTrackingService.addToDynamicSteps(translator(messages.removeLocation), false, currentStep.mlStepName, authHeader);
            onCancel();
            MLNavigationStepsTrackingService.completeCurrentStep(`${item.address.addressLine1} ${item.address.city} ${item.address.state} ${item.address.postalCode}`, authHeader);
        };

        const componentProps = {
            title: translator(messages.makeChanges),
            alertEntity: 'location',
            onAddAction: addLocation,
            overrideProps: {
                submissionVM,
                editLocation,
                removeLocation
            },
            CustomComponent: MLLocationListPopup
        };

        Identify('Endorsement Step Reached', { step: 'Locations Screen' }, submissionVM, authHeader)

        modalApi.showModal(
            <MLModalWithAlerts {...componentProps} />
        );
    };

    const openPUPVehicleModal = () => {
        const newStepID = paCoverableVal ? 'endorsementPaVehicles' : 'endorsementPupVehicles';

        const addVehicle = (onCancel) => {
            MLPolicyChangeDataHolderService.setPageAction('add');
            const vehicle = currentLob.value.createVehicle();
            vehicle.isSelected = true;
            vehicle.type = 'private_passenger_autos_ml';
            vehicle.isReplacing = false;
            vehicle.isEditing = false;
            vehicle.policyState = _.get(submissionVM, 'baseData.policyAddress.state.value.code');
            vehicle.error = {
                message: undefined
            };
            onCancel();
            MLEndorsementFlowUtil.addAndNavigateToSelectedStep(newStepID, currentSteps, currentStepIndex, changeNextSteps, goNext, productCode);
        };

        const replaceVehicle = (item, onCancel) => {
            MLPolicyChangeDataHolderService.setPageAction('replace');
            const replacedVehicleDisplayName = item.getDisplayName();

            const replacedVehicle = _.cloneDeep(item);
            MLPolicyChangeDataHolderService.setReplacedFixedId(replacedVehicle.vin);

            currentLob.value.removeVehicle(item);
            item = currentLob.value.createVehicle();

            item.vehicleBeingReplaced = replacedVehicleDisplayName;
            item.isSelected = true;
            item.isReplacing = true;
            item.error = {
                message: undefined
            };

            onCancel();
            MLEndorsementFlowUtil.addAndNavigateToSelectedStep(newStepID, currentSteps, currentStepIndex, changeNextSteps, goNext, productCode);
        };

        const editVehicle = (item, onCancel) => {
            MLPolicyChangeDataHolderService.setPageAction('edit');
            item.isSelected = true;
            item.isReplacing = false;
            item.isEditing = true;
            item.error = {
                message: undefined
            };
            onEditAlertMsg();
            onCancel();
            MLEndorsementFlowUtil.addAndNavigateToSelectedStep(newStepID, currentSteps, currentStepIndex, changeNextSteps, goNext, productCode);
        };

        const removeVehicle = (item, onCancel) => {
            MLPolicyChangeDataHolderService.setPageAction('remove');
            const removedVehicle = _.cloneDeep(item);
            currentLob.value.removeVehicle(item);

            const alert = {
                alertName: alertNames.removedVehicleName,
                formattedMessageName: 'xVehicleWillBeRemoved',
                messagePram: isAgent ? removedVehicle.getDisplayNameWithBodyTypeAndTrim(viewModelService.productMetadata, translator) : removedVehicle.getDisplayName(),
                actionFn: () => undoVehicleRemoval(pupVehiclesVM, removedVehicle)
            };

            alertMessages.splice(0);
            alertMessages.push(alert);

            MLNavigationStepsTrackingService.addToDynamicSteps(translator(messages.removeVehicle), !currentStep.existingStep, currentStep.mlStepName, authHeader);
            const details = {
                data: `${item.year} ${item.make} ${item.model}`,
                fixedId: item.vin,
                pageAction: MLPolicyChangeDataHolderService.getPageAction()
            };
            MLNavigationStepsTrackingService.completeCurrentStep(details, authHeader);
            onCancel();
            showChangesAlerts();
        };

        const hasErrors = () => {
            return !(pupVehiclesVM.aspects.valid && pupVehiclesVM.aspects.subtreeValid) || pupVehiclesVM.value.filter((vehicle) => vehicle.error === true).length > 0;
        };

        const componentProps = {
            title: translator(messages.makeChanges),
            alertEntity: 'pupVehicle',
            hasErrors: hasErrors(),
            onAddAction: addVehicle,
            viewModelService,
            overrideProps: {
                vehicles: pupVehiclesVM.value,
                replaceVehicle,
                editVehicle,
                removeVehicle
            },
            CustomComponent: MLPUPVehicleListPopup
        };

        Identify('Endorsement Step Reached', { step: 'Vehicles Screen' }, submissionVM, authHeader)

        modalApi.showModal(
            <MLModalWithAlerts {...componentProps} />
        );
    };

    const openRentedTrailerCamperListModal = (wizardStepID) => {

        console.log("wizaaard stp ID:::::::", wizardStepID);
        const vehicleVM = submissionVM?.lobData?.personalAuto?.coverables?.vehicles || { value: [] }
        const allVehicles = Array.isArray(vehicleVM.value) ? vehicleVM.value : [];
        console.log("vehicle VM:::", vehicleVM);
        console.log("allVehicle:::", allVehicles)

        const rentedTrailerCamperRows = [];
        allVehicles.forEach(vehicle => {
            const rtcArray = vehicle.rentedTrailerOrCamper_Ext ?? [];
            rtcArray.forEach(rtc => {
                rentedTrailerCamperRows.push(rtc);
            });
        });

        const addRentedTrailerCamper = (onCancel) => {
            console.log(">> addRTC called")
            MLPolicyChangeDataHolderService.setPageAction('add');
            onCancel();
            const detailStepId = "endorsementPaRentedTrailerCamperPolChange";
            MLEndorsementFlowUtil.addAndNavigateToSelectedStep(detailStepId, currentSteps, currentStepIndex, changeNextSteps, goNext, productCode);
            console.log("+++++++", wizardStepID, currentSteps, currentStepIndex, changeNextSteps, goNext, productCode)
        };

        const onRentedTrailerEdit = (item, onCancel) => {
            console.log(">> editRTC called", item);

            const detailStepId = "endorsementPaRentedTrailerCamperPolChange";
            MLPolicyChangeDataHolderService.setPageAction('edit');
            item.isSelected = true;
            item.isReplacing = false;
            item.isEditing = true;
            item.error = {
                message: undefined
            };
            onCancel();
            MLEndorsementFlowUtil.addAndNavigateToSelectedStep(detailStepId, currentSteps, currentStepIndex, changeNextSteps, goNext, productCode);
        };

        const onRentedTrailerRemove = (item, onCancel) => {
            console.log(">> removeRTC called", item);
            const detailStepId = "endorsementPaListRentedTrailerCamper";
            MLPolicyChangeDataHolderService.setPageAction("remove");
            const removedVehicle = _.cloneDeep(item);

            const dynamicStepLabel = `${item?.year} ${item?.make} ${item?.model}`;
            paCoverableVal.addOrRemoveRentedTDC_Ext(item);

            MLEndorsementFlowUtil.addAndNavigateToSelectedStep(
                detailStepId,
                currentSteps,
                currentStepIndex,
                changeNextSteps,
                goNext,
                productCode
            );
            const details = {
                data: dynamicStepLabel,
                fixedId: removedVehicle.fixedId,
                pageAction: MLPolicyChangeDataHolderService.getPageAction()
            };

            MLNavigationStepsTrackingService.completeCurrentStep(details, authHeader);
            onCancel();

        };

        const componentProps = {
            title: translator(messages.makeChanges),
            model: {},
            overrideProps: {
                submissionVM,
                rentedTrailerCamperRows,
                addRentedTrailerCamper,
                viewModelService,
                authHeader,
                showProgressDialog,
                hideProgressDialog,
                EndorsementService,
                onRentedTrailerEdit,
                onRentedTrailerRemove,
            },
            CustomComponent: MLRentedTrailerCamperTablePopup,
            showFooterOnCustomComponent: false,
            additionalIPEStyle: "customFooterModal",
        };

        modalApi.showModal(<FormModalPopover {...componentProps} />);
    };

    const showModal = (stepID) => {
        const canExclude = submissionVM.baseData.value.canExcludeDrivers_ML;
        switch (stepID) {
            case 'endorsementPaListHouseholdMembers':
                openDriverModal('household', 'endorsementPaHouseholdMembers');
                break;
            case 'endorsementPaListDrivers':
                openDriverModal('rated', 'endorsementPaDrivers');
                break;
            case 'endorsementPaListDriverDiscoveryReview':
                openDriverDiscoveryReviewModal('endorsementPaDriverDiscoveryReview');
                break;
            case 'endorsementPaListExcludedDrivers':
                if (canExclude) {
                    openDriverModal('excluded', 'endorsementPaExcludedDrivers');
                }
                break;
            case 'endorsementPupListWatercraft':
                openWatercraftModal();
                break;
            case 'endorsementPupListBusinessActivities':
                checkObjectValidity(businessActivitiesVM, 'toSync', false);
                openBusinessActivityModal();
                break;
            case 'endorsementPupListNonDrivingVehicleOperators':
                openPUPVehicleOperatorModal('household', canExclude);
                break;
            case 'endorsementPupListRatedVehicleOperators':
                openPUPVehicleOperatorModal('rated', canExclude);
                break;
            case 'endorsementPupListExcludedVehicleOperators':
                openPUPVehicleOperatorModal('excluded', canExclude);
                break;
            case 'endorsementPupListYourPolicies':
                checkObjectValidity(underlyingPoliciesVM, 'partialAdditionFlag', false);
                openUnderlyingPolicyModal();
                break;
            case 'PCPAVehicleListPolChange':
                createVehicleListModal(paModel)
                break;
            case 'endorsementPupListLocations':
                openPUPLocationModal();
                break;
            case 'endorsementPupListVehicles':
                checkObjectValidity(pupVehiclesVM);
                pupVehiclesVM.value.forEach((veh) => {
                    veh.isSelected = false;
                });
                openPUPVehicleModal();
                break;
            case 'endorsementPaListRentedTrailerCamper':
                openRentedTrailerCamperListModal(paModel)
                break;
            default:
                Identify('Endorsement Step Reached', { step: 'Additional Changes Screen' }, submissionVM, authHeader)
                break;
        }
    };

    const saveToEndorsement = useCallback(() => {
        const promise = EndorsementService.saveEndorsement([submissionVM.value], authHeader);
        showProgressDialog(messages.savingEndorsement, promise);
        promise.then((policyChangeDTO) => {
            const policyChange = new PolicyChange(policyChangeDTO);
            const newVm = viewModelService.create(policyChange, 'pc', 'edge.capabilities.policychange.dto.PolicyChangeDataDTO');
            updateWizardSubmissionData(newVm);
        });
        return promise;
    }, [EndorsementService, authHeader, showProgressDialog, submissionVM, updateWizardSubmissionData, viewModelService]);

    const makeAdditionalChangeForStep = (newStep) => {
        MLTagManagerService.sendLinkClickEvent(`Make Additional Changes_${translator(newStep.title)}`);
        if (currentSteps[currentStepIndex].id === newStep.id) {
            showModal(newStep.id);
        } else {
            MLEndorsementFlowUtil.addAndNavigateToSelectedStep(newStep.id, currentSteps, currentStepIndex, changeNextSteps, goNext, productCode);
        }
    };

    const removeSuccessNotificationsOnChange = () => {
        clearSuccessAlerts();
        if (alertMessages && alertMessages.length > 0) {
            alertMessages.forEach((alert) => {
                const alertType = alert.type ? alert.type : 'success';
                if (alertType === 'success') {
                    removeMessage(alert, true);
                }
            })
        }
    }

    const onMakeAdditionalChange = (e) => {
        const index = e.index;
        const change = availableAddlChanges[index];
        // To Remove Success Notifications on selecting another Change
        removeSuccessNotificationsOnChange();
        if (saveOnAdditionalChange) {
            setSaveOnAdditionalChange(false);
            saveToEndorsement().then(() => {
                makeAdditionalChangeForStep(change);
            });
        } else {
            makeAdditionalChangeForStep(change);
        }

        if (isAgent) {
            PolChangeTrackEvent('Endorsement Step Submitted', false, submissionVM, authHeader, {
                step: 'PolChange Additional Changes Screen',
                action: 'Additional Changes Submitted'
            });
        }
    };

    const quoteDetailsPageVisited = () => {
        return isAmpMode && wasEndorsementQuoteDetailsInVisitedSteps;
    };

    const shouldSkipQualPage = () => {
        return MLNavigationStepsTrackingService.shouldSkipQualificationsScreen(submissionVM.value);
    };

    const isNJAutoPolicy = useCallback(() => {
        const hasPa = _.has(submissionVM, 'lobData.personalAuto.value');
        const polState = _.get(submissionVM, 'baseData.policyAddress.state.value.code');
        return hasPa && polState === 'NJ';
    }, [submissionVM]);

    const isVehicleOnPolicy = useCallback(() => {
        return _.get(submissionVM, 'lobData.personalAuto.coverables.vehicles.value.length', 0) > 0;
    }, [submissionVM]);

    const isDriverOnPolicy = useCallback(() => {
        return _.get(submissionVM, 'lobData.personalAuto.coverables.drivers.value.length', 0) > 0;
    }, [submissionVM]);

    const isOnlyVehicleTrailer = useCallback(() => {
        const vehicles = _.get(submissionVM, 'lobData.personalAuto.coverables.vehicles.value', []);
        const isTrailer = vehicles.length < 2
            ? vehicles.some((vehicle) => { return vehicle.category_ML === 'trailer'; })
            : false;

        if (isTrailer) {
            const contactUsError = {
                customError: {
                    contactUsMessage: isQnB ? messages.trailerErrorQnB : messages.trailerError,
                    quoteID: _.get(submissionVM, 'quoteID.value')
                }
            };
            Promise.reject((contactUsError));
            return true;
        }
    }, [submissionVM]);

    const checkPARules = useCallback(() => {
        let ignoreVehicleWarning = false;

        if (missingVehicleOnPolicy) {
            ignoreVehicleWarning = true;
        }

        const hasPaLob = _.has(submissionVM, 'lobData.personalAuto.value');
        if (hasPaLob && isAmpMode) {
            const missingVeh = ignoreVehicleWarning ? false : !isVehicleOnPolicy();
            setMissingVehicleOnPolicy(missingVeh);
            return isOnlyVehicleTrailer() || !missingVeh;
        }

        return true;
    }, [isAmpMode, isOnlyVehicleTrailer, isVehicleOnPolicy, missingVehicleOnPolicy, submissionVM]);

    const next = useCallback(() => {

        if (isAgent) {
            PolChangeTrackEvent('Endorsement Step Submitted', false, submissionVM, authHeader, {
                step: 'PolChange Additional Changes Screen',
                action: 'Additional Changes Submitted'
            });
        }

        if (isPersonalAuto && !checkPARules()) {
            console.error(new Error('Cannot proceed due to a failure in the validation of the PA Rules'));
            return;
        }

        if (isPersonalUmbrella) {
            const errorMessages = endorsementValidateAllExposures(pupModel);
            if (!!errorMessages && errorMessages.length > 0) {
                errorMessages.forEach((errMsg) => {
                    addErrorAlert(translator(errMsg, {
                        strong: (chunks) => <strong>{chunks}</strong>
                    }), 'exposureError');
                });
                return;
            }
        }

        if (isPersonalAuto) {
            if (MLPolicyChangeDataHolderService.getPageAction() === 'edit') {
                const vehicleVM = _.get(submissionVM, 'lobData.personalAuto.coverables.vehicles.value').filter((vehicle) => (
                    (vehicle.financeCategory_ML === 'financed' || vehicle.financeCategory_ML === 'leased')
                    && _.size(vehicle.additionalInterests) === 0)
                );

                if (!_.isEmpty(vehicleVM)) {
                    setShowErrorMessagetoAddInterestedParty(true);
                    window.scrollTo(0, 0);
                    return false;
                }
            }
        }

        MLDisclosureUtil.setRequoteAfterMvr(submissionVM.value.jobID, false);
        if (isAmpMode && wasEndorsementQuoteDetailsInVisitedSteps && !isNJAutoPolicy()) {
            const promise = EndorsementService.saveAndQuote(submissionVM.value, authHeader);
            showProgressDialog(messages.quotingPolicyChange, promise);
            promise.then((pc) => {
                MLTagManagerService.sendFormStepPolicyChangeStep();
                const policyChange = new PolicyChange(pc);
                const newVm = viewModelService.create(policyChange, 'pc', 'edge.capabilities.policychange.dto.PolicyChangeDataDTO');
                updateWizardSubmissionData(newVm);

                // go to policy summary
                const quoteDetailsStepIndex = _.findIndex(steps, ({ mlStepName }) => mlStepName === endorsementQuoteDetails);
                if (quoteDetailsStepIndex > 0) {
                    const remainingSteps = steps.slice(quoteDetailsStepIndex, steps.length);
                    changeNextSteps(remainingSteps);
                }
                goNext();
            });
        } else {
            if (MLNavigationStepsTrackingService.shouldSkipQualificationsScreen(submissionVM.value)) {
                // skip qualification and proceed to policy summary
                const summaryStepIndex = _.findIndex(
                    steps,
                    ({ mlStepName }) => mlStepName === 'endorsementQuoteDetails'
                );
                if (summaryStepIndex !== -1) {
                    const remainingSteps = steps.slice(summaryStepIndex, steps.length);
                    changeNextSteps(remainingSteps);
                }
            } else {
                // go to Qualification step
                const additionalChangesStepIndex = _.findIndex(
                    steps,
                    ({ id }) => id === 'qualificationPolicyChange'
                );
                if (additionalChangesStepIndex > 0) {
                    const remainingSteps = steps.slice(additionalChangesStepIndex, steps.length);
                    changeNextSteps(remainingSteps);
                }
            }
            goNext();
        }


    }, [EndorsementService, addErrorAlert, authHeader, changeNextSteps, checkPARules, endorsementValidateAllExposures, goNext, isAmpMode, isNJAutoPolicy, isPersonalAuto, isPersonalUmbrella, pupModel, showProgressDialog, steps, submissionVM.value, translator, updateWizardSubmissionData, viewModelService, wasEndorsementQuoteDetailsInVisitedSteps]);

    const onRemovePlaceholderPolicyAndProceed = useCallback(() => {

        if (isPersonalUmbrella) {
            const placeholderPolicy = pupModel.value.underlyingPolicies.find((ulPolicy) => ulPolicy.ulPolicyFixID === 'new');
            if (placeholderPolicy) {
                pupModel.value.removeUnderlyingPolicy(placeholderPolicy);
            }
        }

        next();
    }, [isPersonalUmbrella, next, pupModel]);

    const checksforRatedDriver = useCallback(() => {
        if (isDriverOnPolicy()) {
            const drivers = _.get(submissionVM, 'lobData.personalAuto.coverables.drivers.value');
            const ratedDrivers = _.filter(drivers, { type_ML: 'rated' });
            _.each(ratedDrivers, (driver) => {
                if (!(_.has(driver, 'ageFirstLicensed_ML')
                    && _.has(driver, 'maritalStatus_ML')
                    && _.has(driver, 'occupation_Ext')
                )) {
                    const isAlertAlreadyExists = _.filter(alertMessages, { alertName: alertNames.driverChangedToRatedPlsUpdateDriver })
                    if (isAlertAlreadyExists.length > 0) {
                        return false;
                    }
                    const alertMsg = {
                        type: 'warning',
                        alertName: alertNames.driverChangedToRatedPlsUpdateDriver,
                        formattedMessageName: 'driverChangedToRatedPlsUpdateDriver'
                    };
                    alertMessages.push(alertMsg);
                }
            })
        }
    }, []);

    useEffect(() => {
        checksforRatedDriver();
        _.set(submissionVM, 'value.stayOnStepML', true);
        updateWizardSubmissionData(submissionVM);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const numberOfAlerts = getNumberOfAlerts()
        if (alertMessages?.length > 0 && numberOfAlerts < 1) {
            showChangesAlerts(false)
        }
    }, [alertMessages, showChangesAlerts, getNumberOfAlerts]);


    useEffect(() => {
        // if (_.get(submissionVM, 'status.value.code') === 'Quoted') {
        //     return;
        // }

        showModal(currentSteps[currentStepIndex].id);
        showChangesAlerts(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getNextDescription = () => {
        const showPolSummaryNext = (quoteDetailsPageVisited() && !isPersonalUmbrella) || shouldSkipQualPage();

        return showPolSummaryNext ?
            <FormattedMessage
                {...messages.nextDescriptionPolSummary}
                values={{
                    bold: (
                        <strong>{translator(messages.nextBoldPolSummary)}</strong>
                    )
                }}
            /> :
            <FormattedMessage
                {...messages.nextDescriptionAddlPolInfo}
                values={{
                    bold: (
                        <strong>{translator(messages.nextBoldAddlPolInfo)}</strong>
                    )
                }}
            />
    };

    const stepBtnOverrideProps = useCallback(() => {
        const overrides = availableAddlChanges.map((step, index) => {
            return {
                [`stepBtn${index}`]: {
                    title: step.id === 'endorsementPaListHouseholdMembers' && isModernProduct ? translator(messages.NonDriversTooltip) : translator(step.mlDescription),
                    content: step.id === 'endorsementPaListHouseholdMembers' && isModernProduct ? translator(messages.nonDrivers) : [step.label],
                }
            };
        });

        return Object.assign({}, ...overrides);
    }, [availableAddlChanges, translator]);

    const overrideProps = {
        addlChangesContainer: {
            className: isAgent ? 'ml-additional-changes page-content-gpa-policy-change' : 'ml-additional-changes'
        },
        addInterestedPartyError: {
            visible: showErrorMessagetoAddInterestedParty
        },
        nonAmpP: {
            visible: !isAmpMode
        },
        oosComponent: {
            isOOSConflict,
            isAgent
        },
        stepIterator: {
            data: availableAddlChanges
        },
        nextButton: {
            disabled: isOOSConflict
        },
        nextDescription: {
            content: getNextDescription()
        },
        ...stepBtnOverrideProps()
    };

    const resolvers = {
        resolveCallbackMap: {
            onMakeAdditionalChange,
            onRemovePlaceholderPolicyAndProceed
        },
        resolveComponentMap: {
            mloutofsequenceconflictcomponent: MLOutOfSequenceConflictComponent
        }
    };

    return (
        <WizardPage
            showNext={false}
            showPrevious={false}
            showCancel={false}
            policyChangePageHeaderML={isAgent ? messages.makeChanges : messages.needMakeChanges}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={wizardData}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                classNameMap={resolvers.resolveClassNameMap}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
            />
        </WizardPage>
    );
}

AdditionalChangesPage.propTypes = wizardProps;
export default AdditionalChangesPage;
